import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import { Model } from 'vue-api-query';
import NProgress from 'nprogress';
import RateLimit from 'axios-rate-limit';
import Vue2Filters from 'vue2-filters';
import VueBarcodeScanner from 'vue-barcode-scanner';
import VueToasted from 'vue-toasted';
import vueSmoothScroll from 'vue2-smooth-scroll'
import VueMask from 'v-mask';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm';
import VCalendar from 'v-calendar';
import fileDownload from 'js-file-download';

import App from './App.vue';
import router from './router';
import store from './store';
import Filters from './_filters';
import titleMixin from '@/mixins/titleMixin';

import BarcodeParserPlugin from '@/plugins/barcode-parser';
import EchoPlugin from '@/plugins/echo';
import QzTray from '@/plugins/qztray';
import LabelGeneratorPlugin from '@/plugins/label-generator';
import AddFlagModal from '@/components/AddFlagModal';
import EditFlagModal from '@/components/EditFlagModal';
import InputSanitizerPlugin from '@/plugins/input-sanitizer';




Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vue2Filters);
Vue.use(VueBarcodeScanner, {
    sound: true,
    soundSrc: '/scan.mp3',
    callbackAfterTimeout: true,
    sensitivity: 40,
});
Vue.use(VueToasted, { theme: 'toasted-primary', duration: 5000, position: 'bottom-right', iconPack: 'fontawesome' });
Vue.use(Filters);
Vue.use(vueSmoothScroll, {offset: -75});
Vue.mixin(titleMixin);
Vue.use(VueMask);
Vue.use(BarcodeParserPlugin);
Vue.use(EchoPlugin, { store });
Vue.use(LabelGeneratorPlugin);
Vue.use(InputSanitizerPlugin);
Vue.use(VCalendar, {
    componentPrefix: 'vc'
});
Vue.use(QzTray, {
    certificatePromiseCallback: function (resolve) {
        let cert = sessionStorage.getItem('qz_cert');
        if (cert === null) {
            axiosInstance.get('/qzprint/certificate').then((response) => {
                cert = atob(response.data);
                sessionStorage.setItem('qz_cert', cert);
                resolve(cert);
            });
        } else {
            resolve(cert);
        }
    },
    signaturePromiseCallback: function (toSign) {
        return function (resolve, reject) {
            axiosInstance.post('/qzprint/sign', {message: toSign})
                .then((response) => {
                    resolve(response.data);
                }, reject);
        };
    }
});
const US_STATES_UNFILTERED = [
    {value: null, text: 'Select State', disabled: true},
    {value: 'AL', text:'(AL) Alabama'},
    {value: 'AK', text:'(AK) Alaska'},
    {value: 'AZ', text:'(AZ) Arizona'},
    {value: 'AR', text:'(AR) Arkansas'},
    {value: 'CA', text:'(CA) California'},
    {value: 'CO', text:'(CO) Colorado'},
    {value: 'CT', text:'(CT) Connecticut'},
    {value: 'DE', text:'(DE) Delaware'},
    {value: 'DC', text:'(DC) District of Columbia'},
    {value: 'FL', text:'(FL) Florida'},
    {value: 'GA', text:'(GA) Georgia'},
    {value: 'HI', text:'(HI) Hawaii'},
    {value: 'ID', text:'(ID) Idaho'},
    {value: 'IL', text:'(IL) Illinois'},
    {value: 'IN', text:'(IN) Indiana'},
    {value: 'IA', text:'(IA) Iowa'},
    {value: 'KS', text:'(KS) Kansas'},
    {value: 'KY', text:'(KY) Kentucky'},
    {value: 'LA', text:'(LA) Louisiana'},
    {value: 'ME', text:'(ME) Maine'},
    {value: 'MD', text:'(MD) Maryland'},
    {value: 'MA', text:'(MA) Massachusetts'},
    {value: 'MI', text:'(MI) Michigan'},
    {value: 'MN', text:'(MN) Minnesota'},
    {value: 'MS', text:'(MS) Mississippi'},
    {value: 'MO', text:'(MO) Missouri'},
    {value: 'MT', text:'(MT) Montana'},
    {value: 'NE', text:'(NE) Nebraska'},
    {value: 'NV', text:'(NV) Nevada'},
    {value: 'NH', text:'(NH) New Hampshire'},
    {value: 'NJ', text:'(NJ) New Jersey'},
    {value: 'NM', text:'(NM) New Mexico'},
    {value: 'NY', text:'(NY) New York'},
    {value: 'NC', text:'(NC) North Carolina'},
    {value: 'ND', text:'(ND) North Dakota'},
    {value: 'OH', text:'(OH) Ohio'},
    {value: 'OK', text:'(OK) Oklahoma'},
    {value: 'OR', text:'(OR) Oregon'},
    {value: 'PA', text:'(PA) Pennsylvania'},
    // {value: 'PR', text:'(PR) Puerto Rico'},
    {value: 'RI', text:'(RI) Rhode Island'},
    {value: 'SC', text:'(SC) South Carolina'},
    {value: 'SD', text:'(SD) South Dakota'},
    {value: 'TN', text:'(TN) Tennessee'},
    {value: 'TX', text:'(TX) Texas'},
    {value: 'UT', text:'(UT) Utah'},
    {value: 'VT', text:'(VT) Vermont'},
    {value: 'VA', text:'(VA) Virginia'},
    {value: 'WA', text:'(WA) Washington'},
    {value: 'WV', text:'(WV) West Virginia'},
    {value: 'WI', text:'(WI) Wisconsin'},
    {value: 'WY', text:'(WY) Wyoming'},
];
Vue.prototype.US_STATES_UNFILTERED = (US_STATES_UNFILTERED);
const US_STATES = [
    {value: null, text: 'Select State', disabled: true},
    {value: 'AL', text:'(AL) Alabama'},
    {value: 'AK', text:'(AK) Alaska'},
    {value: 'AZ', text:'(AZ) Arizona'},
    {value: 'AR', text:'(AR) Arkansas'},
    {value: 'CA', text:'(CA) California'},
    {value: 'CO', text:'(CO) Colorado'},
    {value: 'CT', text:'(CT) Connecticut'},
    {value: 'DE', text:'(DE) Delaware'},
    {value: 'DC', text:'(DC) District of Columbia'},
    {value: 'FL', text:'(FL) Florida'},
    {value: 'GA', text:'(GA) Georgia'},
    {value: 'HI', text:'(HI) Hawaii'},
    {value: 'ID', text:'(ID) Idaho'},
    {value: 'IL', text:'(IL) Illinois'},
    {value: 'IN', text:'(IN) Indiana'},
    {value: 'IA', text:'(IA) Iowa'},
    {value: 'KS', text:'(KS) Kansas'},
    {value: 'KY', text:'(KY) Kentucky'},
    {value: 'LA', text:'(LA) Louisiana'},
    {value: 'ME', text:'(ME) Maine'},
    {value: 'MD', text:'(MD) Maryland'},
    {value: 'MA', text:'(MA) Massachusetts'},
    {value: 'MI', text:'(MI) Michigan'},
    {value: 'MN', text:'(MN) Minnesota'},
    {value: 'MS', text:'(MS) Mississippi'},
    {value: 'MO', text:'(MO) Missouri'},
    {value: 'MT', text:'(MT) Montana'},
    {value: 'NE', text:'(NE) Nebraska'},
    {value: 'NV', text:'(NV) Nevada'},
    {value: 'NH', text:'(NH) New Hampshire'},
    {value: 'NJ', text:'(NJ) New Jersey'},
    {value: 'NM', text:'(NM) New Mexico'},
    {value: 'NY', text:'(NY) New York'},
    {value: 'NC', text:'(NC) North Carolina'},
    {value: 'ND', text:'(ND) North Dakota'},
    {value: 'OH', text:'(OH) Ohio', disabled: true},
    {value: 'OK', text:'(OK) Oklahoma'},
    {value: 'OR', text:'(OR) Oregon'},
    {value: 'PA', text:'(PA) Pennsylvania'},
    // {value: 'PR', text:'(PR) Puerto Rico'},
    {value: 'RI', text:'(RI) Rhode Island'},
    {value: 'SC', text:'(SC) South Carolina'},
    {value: 'SD', text:'(SD) South Dakota'},
    {value: 'TN', text:'(TN) Tennessee'},
    {value: 'TX', text:'(TX) Texas'},
    {value: 'UT', text:'(UT) Utah'},
    {value: 'VT', text:'(VT) Vermont'},
    {value: 'VA', text:'(VA) Virginia'},
    {value: 'WA', text:'(WA) Washington'},
    {value: 'WV', text:'(WV) West Virginia'},
    {value: 'WI', text:'(WI) Wisconsin'},
    {value: 'WY', text:'(WY) Wyoming'},
];
Vue.prototype.US_STATES = (US_STATES);
Vue.prototype.US_STATES_LIST = [
    {
        name: 'Select State',
        types: [
            {id: 'AL', name: '(AL) Alabama'},
            {id: 'AK', name: '(AK) Alaska'},
            {id: 'AZ', name: '(AZ) Arizona'},
            {id: 'AR', name: '(AR) Arkansas'},
            {id: 'CA', name: '(CA) California'},
            {id: 'CO', name: '(CO) Colorado'},
            {id: 'CT', name: '(CT) Connecticut'},
            {id: 'DE', name: '(DE) Delaware'},
            {id: 'DC', name: '(DC) District of Columbia'},
            {id: 'FL', name: '(FL) Florida'},
            {id: 'GA', name: '(GA) Georgia'},
            {id: 'HI', name: '(HI) Hawaii'},
            {id: 'ID', name: '(ID) Idaho'},
            {id: 'IL', name: '(IL) Illinois'},
            {id: 'IN', name: '(IN) Indiana'},
            {id: 'IA', name: '(IA) Iowa'},
            {id: 'KS', name: '(KS) Kansas'},
            {id: 'KY', name: '(KY) Kentucky'},
            {id: 'LA', name: '(LA) Louisiana'},
            {id: 'ME', name: '(ME) Maine'},
            {id: 'MD', name: '(MD) Maryland'},
            {id: 'MA', name: '(MA) Massachusetts'},
            {id: 'MI', name: '(MI) Michigan'},
            {id: 'MN', name: '(MN) Minnesota'},
            {id: 'MS', name: '(MS) Mississippi'},
            {id: 'MO', name: '(MO) Missouri'},
            {id: 'MT', name: '(MT) Montana'},
            {id: 'NE', name: '(NE) Nebraska'},
            {id: 'NV', name: '(NV) Nevada'},
            {id: 'NH', name: '(NH) New Hampshire'},
            {id: 'NJ', name: '(NJ) New Jersey'},
            {id: 'NM', name: '(NM) New Mexico'},
            {id: 'NY', name: '(NY) New York'},
            {id: 'NC', name: '(NC) North Carolina'},
            {id: 'ND', name: '(ND) North Dakota'},
            {id: 'OH', name: '(OH) Ohio', $isDisabled: true},
            {id: 'OK', name: '(OK) Oklahoma'},
            {id: 'OR', name: '(OR) Oregon'},
            {id: 'PA', name: '(PA) Pennsylvania'},
            // {id: 'PR', name: '(PR) Puerto Rico'},
            {id: 'RI', name: '(RI) Rhode Island'},
            {id: 'SC', name: '(SC) South Carolina'},
            {id: 'SD', name: '(SD) South Dakota'},
            {id: 'TN', name: '(TN) Tennessee'},
            {id: 'TX', name: '(TX) Texas'},
            {id: 'UT', name: '(UT) Utah'},
            {id: 'VT', name: '(VT) Vermont'},
            {id: 'VA', name: '(VA) Virginia'},
            {id: 'WA', name: '(WA) Washington'},
            {id: 'WV', name: '(WV) West Virginia'},
            {id: 'WI', name: '(WI) Wisconsin'},
            {id: 'WY', name: '(WY) Wyoming'},
        ]
    }
];
Vue.prototype.US_STATES_LIST_FILTERED = [
    {
        name: 'Select State',
        types: [
            {id: 'AL', name: '(AL) Alabama'},
            {id: 'AK', name: '(AK) Alaska'},
            {id: 'AZ', name: '(AZ) Arizona'},
            {id: 'AR', name: '(AR) Arkansas'},
            {id: 'CA', name: '(CA) California'},
            {id: 'CO', name: '(CO) Colorado'},
            {id: 'CT', name: '(CT) Connecticut'},
            {id: 'DE', name: '(DE) Delaware'},
            {id: 'DC', name: '(DC) District of Columbia'},
            {id: 'FL', name: '(FL) Florida'},
            {id: 'GA', name: '(GA) Georgia'},
            {id: 'HI', name: '(HI) Hawaii'},
            {id: 'ID', name: '(ID) Idaho'},
            {id: 'IL', name: '(IL) Illinois'},
            {id: 'IN', name: '(IN) Indiana'},
            {id: 'IA', name: '(IA) Iowa'},
            {id: 'KS', name: '(KS) Kansas'},
            {id: 'KY', name: '(KY) Kentucky'},
            {id: 'LA', name: '(LA) Louisiana'},
            {id: 'ME', name: '(ME) Maine'},
            {id: 'MD', name: '(MD) Maryland'},
            {id: 'MA', name: '(MA) Massachusetts'},
            {id: 'MI', name: '(MI) Michigan'},
            {id: 'MN', name: '(MN) Minnesota'},
            {id: 'MS', name: '(MS) Mississippi'},
            {id: 'MO', name: '(MO) Missouri'},
            {id: 'MT', name: '(MT) Montana'},
            {id: 'NE', name: '(NE) Nebraska'},
            {id: 'NV', name: '(NV) Nevada'},
            {id: 'NH', name: '(NH) New Hampshire'},
            {id: 'NJ', name: '(NJ) New Jersey'},
            {id: 'NM', name: '(NM) New Mexico'},
            {id: 'NY', name: '(NY) New York'},
            {id: 'NC', name: '(NC) North Carolina'},
            {id: 'ND', name: '(ND) North Dakota'},
            // {id: 'OH', name: '(OH) Ohio'},
            {id: 'OK', name: '(OK) Oklahoma'},
            {id: 'OR', name: '(OR) Oregon'},
            {id: 'PA', name: '(PA) Pennsylvania'},
            // {id: 'PR', name: '(PR) Puerto Rico'},
            {id: 'RI', name: '(RI) Rhode Island'},
            {id: 'SC', name: '(SC) South Carolina'},
            {id: 'SD', name: '(SD) South Dakota'},
            {id: 'TN', name: '(TN) Tennessee'},
            {id: 'TX', name: '(TX) Texas'},
            {id: 'UT', name: '(UT) Utah'},
            {id: 'VT', name: '(VT) Vermont'},
            {id: 'VA', name: '(VA) Virginia'},
            {id: 'WA', name: '(WA) Washington'},
            {id: 'WV', name: '(WV) West Virginia'},
            {id: 'WI', name: '(WI) Wisconsin'},
            {id: 'WY', name: '(WY) Wyoming'},
        ]
    }
];
Vue.prototype.US_STATES_LIST_UNFILTERED = [
    {
        name: 'Select State',
        types: [
            {id: 'AL', name: '(AL) Alabama'},
            {id: 'AK', name: '(AK) Alaska'},
            {id: 'AZ', name: '(AZ) Arizona'},
            {id: 'AR', name: '(AR) Arkansas'},
            {id: 'CA', name: '(CA) California'},
            {id: 'CO', name: '(CO) Colorado'},
            {id: 'CT', name: '(CT) Connecticut'},
            {id: 'DE', name: '(DE) Delaware'},
            {id: 'DC', name: '(DC) District of Columbia'},
            {id: 'FL', name: '(FL) Florida'},
            {id: 'GA', name: '(GA) Georgia'},
            {id: 'HI', name: '(HI) Hawaii'},
            {id: 'ID', name: '(ID) Idaho'},
            {id: 'IL', name: '(IL) Illinois'},
            {id: 'IN', name: '(IN) Indiana'},
            {id: 'IA', name: '(IA) Iowa'},
            {id: 'KS', name: '(KS) Kansas'},
            {id: 'KY', name: '(KY) Kentucky'},
            {id: 'LA', name: '(LA) Louisiana'},
            {id: 'ME', name: '(ME) Maine'},
            {id: 'MD', name: '(MD) Maryland'},
            {id: 'MA', name: '(MA) Massachusetts'},
            {id: 'MI', name: '(MI) Michigan'},
            {id: 'MN', name: '(MN) Minnesota'},
            {id: 'MS', name: '(MS) Mississippi'},
            {id: 'MO', name: '(MO) Missouri'},
            {id: 'MT', name: '(MT) Montana'},
            {id: 'NE', name: '(NE) Nebraska'},
            {id: 'NV', name: '(NV) Nevada'},
            {id: 'NH', name: '(NH) New Hampshire'},
            {id: 'NJ', name: '(NJ) New Jersey'},
            {id: 'NM', name: '(NM) New Mexico'},
            {id: 'NY', name: '(NY) New York'},
            {id: 'NC', name: '(NC) North Carolina'},
            {id: 'ND', name: '(ND) North Dakota'},
            {id: 'OH', name: '(OH) Ohio'},
            {id: 'OK', name: '(OK) Oklahoma'},
            {id: 'OR', name: '(OR) Oregon'},
            {id: 'PA', name: '(PA) Pennsylvania'},
            // {id: 'PR', name: '(PR) Puerto Rico'},
            {id: 'RI', name: '(RI) Rhode Island'},
            {id: 'SC', name: '(SC) South Carolina'},
            {id: 'SD', name: '(SD) South Dakota'},
            {id: 'TN', name: '(TN) Tennessee'},
            {id: 'TX', name: '(TX) Texas'},
            {id: 'UT', name: '(UT) Utah'},
            {id: 'VT', name: '(VT) Vermont'},
            {id: 'VA', name: '(VA) Virginia'},
            {id: 'WA', name: '(WA) Washington'},
            {id: 'WV', name: '(WV) West Virginia'},
            {id: 'WI', name: '(WI) Wisconsin'},
            {id: 'WY', name: '(WY) Wyoming'},
        ]
    }
];
/*
export default{
    name:'US_STATES',
        data(){
            return {
                US_STATES:US_STATES
            }
        }
}*/

const dobover18 = {
    message(field, args) {
        return "invalid dob, must be 18 years of age";
    },
    validate(value, args) {
        var today = new Date();
        var nowyear = today.getFullYear();
        var nowmonth = today.getMonth();
        var nowday = today.getDate();

        var birth = new Date(value);

        var birthyear = birth.getFullYear();
        var birthmonth = birth.getMonth();
        var birthday = birth.getDate();

        var age = nowyear - birthyear;
        var age_month = nowmonth - birthmonth;
        var age_day = nowday - birthday;
        if (age_month < 0 || (age_month == 0 && age_day < 0)) {
            age = parseInt(age) - 1;
            age_month += 12;
        }
        if ((age == 18 && age_month <= 0 && age_day <= 0) || age < 18) {
            return false;
        }
        return true;
    }
};
const dobreasonablerange = {
    message(field, args) {
        return "invalid dob, over 100 years";
    },
    validate(value, args) {
        var today = new Date();
        var nowyear = today.getFullYear();
        var nowmonth = today.getMonth();
        var nowday = today.getDate();

        var birth = new Date(value);

        var birthyear = birth.getFullYear();
        var birthmonth = birth.getMonth();
        var birthday = birth.getDate();

        var age = nowyear - birthyear;
        var age_month = nowmonth - birthmonth;
        var age_day = nowday - birthday;

        if (age_month < 0 || (age_month == 0 && age_day < 0)) {
            age = parseInt(age) - 1;
        }
        if ((age == 100 && age_month >= 0 && age_day >= 0) || age > 100) {
            return false;
        }
        return true;
    }
};
const datenotexpired = {
    message(field, args) {
        return 'Date is expired';
    },
    validate(value, args) {
        var today = new Date();
        today.setUTCHours(0,0,0,0);

        var dateValue = new Date(value);

        if (today > dateValue) {
            // Today is greater than the dateValue, therefore is expired
            return false;
        }
        // Today is not greater than dateValue, still valid
        return true;
    }
};
extend('dobover18',dobover18);
extend('dobreasonablerange',dobreasonablerange);
extend('datenotexpired',datenotexpired);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('AddFlagModal', AddFlagModal);
Vue.component('EditFlagModal', EditFlagModal);
//const axiosInstance = axios.create();
const axiosInstance = axios;

// Axios config

// TODO: condense down to one axios instance
axios.defaults.baseURL = process.env.VUE_APP_API_HOST;
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axiosInstance.defaults.baseURL = process.env.VUE_APP_API_HOST;
axiosInstance.defaults.withCredentials = true;
axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const access_token = localStorage.getItem('access-token');

if (access_token) {
    axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
}

axiosInstance.interceptors.request.use(config => {
    NProgress.start();
    return Promise.resolve(config);
});

axiosInstance.interceptors.response.use(res => {
    NProgress.done();
    return Promise.resolve(res);
}, err => {
    NProgress.done();
    return Promise.reject(err);
});

const rateLimitedAxiosInstance = RateLimit(axiosInstance, {maxRequests: 10, perMilliseconds: 300});

Model.$http = rateLimitedAxiosInstance;
Vue.prototype.$http = rateLimitedAxiosInstance;
Vue.prototype.$http.downloadFile = fileDownload;

NProgress.configure({ showSpinner: false });

let vm = new Vue({
    render: (h) => h(App),
    router,
    store,
}).$mount('#app');
global.vm = vm;